<template>
  <BaseModal modal-content-class="modal_change_info modal_glow">
    <div class="content">
      <form @submit.prevent="updateUsernameAction">
        <h3 class="title">{{ getTranslations.home_modals_change_username_title }}</h3>
        <BaseTextFormInput
          v-model="username"
          :label="getTranslations.home_modals_change_username_placeholder"
          inputId="username"
          inputName="username"
          inputClass="code-input"
          :invalid="hasErrors && showErrors"
          @keyup="check"/>
        <div class="error_text" v-if="repeat && showErrors">
          {{ getTranslations.home_modals_change_username_repeat }}
        </div>
        <div class="error_text" v-else-if="showErrors && !repeat">
          {{ getMessage(messageForUsername) }}
        </div>


        <div class="outline_fancy_btn update_info">
          <button type="submit"
                  @click.prevent="updateUsernameAction()"
                  :class="['fancy_btn', hasErrors || !username ? 'deactivated' : '']">
                  {{ getTranslations.home_modals_change_username_save }}
          </button>
        </div>

        <p class="succ_upd" v-if="success">
          {{ getTranslations.home_modals_change_username_success }}
        </p>


        <div class="upd_disclaimer">
          <img src="/static/images/info.svg">
          <p>{{ getTranslations.home_modals_change_username_repeat_desc }}</p>
        </div>
      </form>
    </div>
  </BaseModal>
</template>

<script>
import { mapGetters, mapState, mapActions, mapMutations } from 'vuex';
import BaseModal from "../../common/modal/BaseModal";
import BaseTextFormInput from "../../common/formInput/BaseTextFormInput";

export default {
  name: 'change-username',
  components: {BaseTextFormInput, BaseModal},
  data() {
    return {
      hasErrors: false,
      success: false,
      repeat: false,
      showErrors: false,
      username: '',
      messageForUsername: '',
    };
  },
  methods: {
    ...mapActions('profile', [
      'changeUsername',
      'storeLoginInfo',
    ]),
    ...mapMutations('common', [
      'updateUsername',
    ]),
    async check(evt) {
      const max = 12;
      const min = 3;
      this.resetValidation();

      if (!this.username) {
        return;
      }

      if (!this.isValidLength(min, max, evt)) {
        return;
      }

      if (!this.isValidFormat()) {
        return;
      }

      await this.checkUsernameAvailability();
    },

    resetValidation() {
      this.hasErrors = false;
      this.messageForUsername = '';
      this.repeat = false;
      this.showErrors = false;
    },

    isValidLength(min, max, evt) {
      if (this.username.length < min) {
        this.messageForUsername = 'visitor_sign_up_3_warning_msg_username_at_least_3_chars_long';
        this.hasErrors = true;
        return false;
      }

      if (this.username.length > max) {
        this.username = this.checkMaxChar(this.username, max, evt);
        this.hasErrors = true;
        return false;
      }

      return true;
    },

    isValidFormat() {
      // eslint-disable-next-line no-useless-escape
      const validUsernameRegex = /^(?!.*[\0\b\n\f\r\t\s-!@#\$%\=.^\&*(\+\/?\[\]|΄΄;:<>}{'"¨,)`~\\])_?.+$/;
      if (!this.username.match(validUsernameRegex)) {
        this.messageForUsername = 'visitor_sign_up_3_warning_msg_username_criteria';
        this.hasErrors = true;
        return false;
      }

      return true;
    },

    async checkUsernameAvailability() {
      try {
        const response = await this.$axios.get(
          `publicapi/checkUsername?username=${this.username}&msisdn=${encodeURIComponent(this.userDetails.msisdn)}`
        );

        const res = response.data.data.msg;

        if (res === 'Username exists') {
          this.messageForUsername = 'visitor_sign_up_3_warning_msg_username_taken_below';
          this.hasErrors = true;
        } else if (res === 'Invalid') {
          this.messageForUsername = 'visitor_sign_up_3_warning_msg_username_blacklist_word';
          this.hasErrors = true;
        } else {
          this.messageForUsername = res;
        }
      } catch (error) {
        console.error('Error checking username availability:', error);
        this.hasErrors = true;
        this.messageForUsername = 'common_error_generic';
      }
    },
    getMessage(key) {
      if (key === 'SERVER_ERROR') return key;
      return this.getTranslations[key] || '';
    },

    checkMaxChar(value, max, evt) {
      if (value.length > max) {
        /* eslint-disable */
        evt = (evt) ? evt : window.event;
        let charCode = (evt.which) ? evt.which : evt.keyCode;
        if (charCode.which < 0x20) {
          return;     // Do nothing
        }
        if (value.length === max) {
          charCode.preventDefault();
        } else if (value.length > max) {
          return value.substring(0, max);
        }
        /* eslint-enable */
      }
    },
    updateUsernameAction() {
      this.repeat = false;
      if (!this.username) return;

      if(!this.hasErrors){
        this.changeUsername({ username: this.username }).then((response) => {
          const res = response.data.responseEnum;
          if (res === 'OPERATION_SUCCESS') {
            this.success = true;
            this.updateUsername(this.username);
            this.storeLoginInfo({ token: response.data.data, username: this.username, rememberMeParameter: true });
            this.showErrors = false;
          } else {
            this.repeat = true;
            this.hasErrors = true;
            this.showErrors = true;
          }
        });
      }else{
        this.showErrors = true;
      }
    },
  },
  computed: {
    ...mapState('common', [
      'userDetails',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/modals/ChangeUsername.vue